import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import "materialize-css";
import "jquery";
import "hammerjs";
import { AppComponent } from './app.component';
import {MaterializeModule} from "angular2-materialize/dist";
import {CommonService} from "./common.service";
import { FormsModule }   from '@angular/forms';
import { HttpModule } from '@angular/http';
import {DashboardComponent, SearchFilterPipe} from './dashboard/dashboard.component';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { BenchmarkComponent } from './benchmark/benchmark.component';
import { CertifiedfacilitatorComponent } from './certifiedfacilitator/certifiedfacilitator.component';
import { FocusareaComponent } from './focusarea/focusarea.component';
import { FacilitatorprogressComponent } from './facilitatorprogress/facilitatorprogress.component';

const appRoutes: Routes = [
  {path: '', component: DashboardComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'login', component: LoginComponent },
  { path: 'benchmark', component: BenchmarkComponent },
  { path: 'certified-facilitator', component: CertifiedfacilitatorComponent },
  { path: 'focus-area', component: FocusareaComponent },
  { path: 'app', component: AppComponent },
  { path: 'facilitator-progress', component: FacilitatorprogressComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    BenchmarkComponent,
    CertifiedfacilitatorComponent,
    FocusareaComponent,
    FacilitatorprogressComponent,
    SearchFilterPipe
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    MaterializeModule,
    BrowserModule,
    FormsModule,
    HttpModule,

  ],
  providers: [CommonService],
  bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/app.module.ts